<div class="custom-dialog">
  <div class="custom-dialog__root">
    <div class="custom-dialog__picture">
      <picture>
        <img
          src="/shared/svg/wallet/payment-processor-error.svg"
          height="157"
          [alt]="title"
        />
      </picture>
    </div>

    <div class="custom-dialog__content">
      <h2 class="custom-dialog__content__title">{{ title }}</h2>
      <p class="custom-dialog__content__subtitle">
        {{ content }}
      </p>
    </div>

    <div class="custom-dialog__actions">
      <ng-container
        [ngTemplateOutlet]="attempts && attempts >= 1 ? action1 : action2"
      ></ng-container>
    </div>
  </div>
</div>

<!-- template for actions -->
<ng-template #action1>
  <button
    mat-flat-button
    color="primary"
    class="fz-button--medium"
    [matDialogClose]="{ source: 'edit-credit-card' }"
  >
    Edit Credit card
  </button>
  <button
    mat-stroked-button
    color="primary"
    class="fz-button--medium"
    [matDialogClose]="{ source: 'try-another-method' }"
  >
    Try another method
  </button>

  <div class="actions-dtls" *ngIf="attempts && attempts > 0">
    <mat-icon>info</mat-icon>
    <p class="mat-body-2">
      You still have
      <b>{{ attempts }} attempt{{ attempts && attempts > 1 ? 's' : '' }}</b>
      to complete your account verification by registering a credit card.
    </p>
  </div>
</ng-template>

<ng-template #action2>
  <button
    mat-flat-button
    color="primary"
    class="fz-button--medium"
    [matDialogClose]="{ source: 'try-another-method' }"
  >
    Try another method
  </button>
  <button
    mat-stroked-button
    color="primary"
    class="fz-button--medium"
    fzOpenZenDesk
  >
    Contact Customer Support
  </button>
</ng-template>
